import { OnboardEducationDetails } from './OnboardEducationDetails';
import { OnboardEmployeePassportVisaInfo } from './OnboardEmployeePassportVisaInfo';
import { OnboardHREmpDoc } from './OnboardHREmpDoc';

export class OnboardEmpEducationInformation {
  educationDetails: OnboardEducationDetails[] = [];
  passportVisaDetails: OnboardEmployeePassportVisaInfo = new OnboardEmployeePassportVisaInfo();
  AdditionalQualifications: OnboardHREmpDoc[] = [];
}
